export default "__VITE_ASSET__DN2g7sIi__"